import { zodToJsonSchema } from 'zod-to-json-schema';

import { LoadWidgetPropsSchema } from '@asurion-core/widget-client/lib/package';
import Editor from '@monaco-editor/react';

import { useCallback, useState } from 'react';

import { Action } from '@asurion-core/mx-asurion-ui-react';

import styled from 'styled-components';

import { usePlaygroundStore } from '../storage';

const jsonSchema = zodToJsonSchema(LoadWidgetPropsSchema, {
  removeAdditionalStrategy: 'strict',
});

const ActionButtonContainer = styled.div``;

export const OptionEditor = () => {
  const [valid, setValid] = useState<boolean>(true);
  const setWidgetParams = usePlaygroundStore((state) => state.setWidgetParams);
  const setEditorValue = usePlaygroundStore((state) => state.setEditorValue);
  const value = usePlaygroundStore((state) => state.editorValue);

  const handleSubmit = useCallback(() => {
    if (value) {
      const parsedValue = JSON.parse(value);
      setWidgetParams(parsedValue);
    }
  }, [setWidgetParams, value]);

  return (
    <>
      <Editor
        defaultLanguage="json"
        height="300px"
        onChange={(next) => setEditorValue(next ?? '')}
        onValidate={(markers) => (markers.length === 0 ? setValid(true) : setValid(false))}
        options={{
          formatOnPaste: true,
          formatOnType: false,
          minimap: { enabled: false },
          wordWrap: 'on',
          wrappingIndent: 'same',
        }}
        value={value}
        onMount={(_editor, monaco) =>
          (
            monaco?.languages.json as unknown as {
              jsonDefaults: { setDiagnosticsOptions: (options: Record<string, unknown>) => void };
            }
          )?.jsonDefaults.setDiagnosticsOptions({
            schemas: [
              {
                fileMatch: ['*'],
                schema: jsonSchema,
                uri: 'https://json-schema.org/draft/2020-12/schema',
              },
            ],
            validate: true,
          })
        }
      />
      <ActionButtonContainer>
        <Action onClick={handleSubmit} state={valid ? 'enabled' : 'disabled'}>
          Preview
        </Action>
      </ActionButtonContainer>
    </>
  );
};
